module.exports = __webpack_public_path__ + "img/ic-draw-slider.14ea0603.svg";